import dynamic from "next/dynamic";

const AccountLayout = dynamic(() => import("../../components/Layouts/Account"));
const OrderDetail = dynamic(() =>
  import("../../components/account/order/detail")
);
const OrderItem = dynamic(() => import("../../components/account/order/item"));
const RentalAction = dynamic(() =>
  import("../../components/account/order/rental")
);
const OrderIndex = () => {
  return (
    <AccountLayout
      title="My Orders"
      subtitle="Manage Your Orders At One Place"
      empty={{
        title: "Oops! No Order Found",
        text: "Shop Now",
        href: "/search",
        body: "Looks You Dont Have Any Order",
      }}
      url="/account/order"
      render={(x) =>
        x.items.map((s) => <OrderItem {...x} orderId={x.id} {...s} />)
      }
    >
      <OrderDetail />
      <RentalAction />
    </AccountLayout>
  );
};

export default OrderIndex;
